export function redirectWithLine() {
  if (navigator.userAgent.indexOf("Line") === -1) return;
  window.location.href = "?openExternalBrowser=1";
}

export function isIOSInAppBrowser(userAgent = navigator.userAgent) {
  const ua = userAgent || "";
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isGoogleApp = /GSA/i.test(ua);
  const isFacebook = /FBAN|FBAV|FBIOS|FB_IAB/i.test(ua);
  const isLine = /Line/i.test(ua);

  return isIOS && (isGoogleApp || isFacebook || isLine);
}

export function redirectWithAndroidFb() {
  let isFbav = navigator.userAgent.indexOf("FBAV") !== -1;
  let isFban = navigator.userAgent.indexOf("FBAN") !== -1;
  let isAndroid = navigator.userAgent.indexOf("Android") !== -1;
  if (!(isFbav || isFban) || !isAndroid) return;
  let url = window.location.href;
  setTimeout(function () {
    location.href =
      "intent:" +
      url +
      "#Intent;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;component=com.android.browser/com.android.browser.BrowserActivity;end";
  }, 500);
}
